import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDeviceContract } from '@nx-fe/services';
import { DeviceContextService } from 'sspapp/services/device-context.service';

@Component({
  selector: 'app-view-device-details',
  templateUrl: './view-device-details.component.html',
  styleUrls: ['./view-device-details.component.scss'],
})
export class ViewDeviceDetailsComponent implements OnInit {
  public device: IDeviceContract;
  public id: string;
  public deviceList;

  constructor(private route: ActivatedRoute, private deviceContextService: DeviceContextService) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.deviceContextService.getDeviceSsp(this.id).then((device: IDeviceContract) => {
        this.device = device;
      });
    });
  }
}
